import script from "./pathImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./pathImage.vue?vue&type=script&setup=true&lang=ts"

import "./pathImage.vue?vue&type=style&index=0&id=6b586728&lang=css"

const __exports__ = script;

export default __exports__